import React, { useRef, useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { GetUsersThunk, ManageUser } from '../../../redux/slices/components/ManageUsers/manageUsersDataSlice'
import { RootState, useAppDispatch } from '../../../redux/store/store'
import { isUUID } from '../../../utils/verifications/uuid/uuid'
import SearcherBar from '../../UIcomponents/SearcherBar/SearcherBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'
import { setSendNotificationModalStateReducer } from '../../../redux/slices/components/ManageUsers/manageUsersModalsSlice'
import useCheckAccess from '../../hooks/useCheckAccess/useCheckAccess'
import * as XLSX from 'xlsx-js-style';
import useGetAllJobNames from '../../hooks/useGetAllJobNames/useGetJobName'
import moment from 'moment'

const HeaderManageUsers = () => {

    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const resetSearch = useRef<any>()

    const accessEdit = useCheckAccess({ id_Category: "Manage_Users", id_Policy: "Notification", id_Action: "Edit" })

    const limit =useSelector((state:RootState) => state.manageUsersData.limit)

    const usersToShow = useSelector((state: RootState) => state.manageUsersData.usersToShow)

    const jobNames = useGetAllJobNames()



    const handleExport2 = () => {
        // Create a new workbook and worksheet
        const data = orderColumnsExcel(usersToShow)
        const worksheet = XLSX.utils.json_to_sheet(data);
        
        // Define column widths
        worksheet["!cols"] = [
            { wch: 20 }, 
            { wch: 20 }, 
            { wch: 20 }, 
            { wch: 25 }, 
            { wch: 20 }, 
            { wch: 30 }, 
            { wch: 22 }, 
            { wch: 50 }, 
            { wch: 20 }, // Column H: Documentos_SAT
            { wch: 24 }, 
            { wch: 20 }, 
            { wch: 30 },
            { wch: 20 },  
            { wch: 35 }, 
            { wch: 20 },  
            { wch: 20 }, 
            { wch: 20 },  
            { wch: 20 }, 
        ];

        // Find the range of the worksheet register_activity

        if(!worksheet['!ref']){
            alert("Error creating excel")
            return
        }
            

        const range = XLSX.utils.decode_range(worksheet['!ref']);

        // Iterate through each row starting from the second row (to skip headers)
        for (let R = range.s.r + 1; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                // Construct the cell address
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });

                // Get the cell object
                const cell = worksheet[cellAddress];

                // Check if the cell exists and contains a value
                if (cell && cell.v !== undefined) {
                    // Apply the style depending on value
                    if (cell.v === true || cell.v === "Completos" || cell.v === "Verificada" || cell.v === "Subida") {
                        cell.s = { fill: { fgColor: { rgb: "FF92D050" } } }; // Green background
                    } else if (cell.v === false || cell.v === "Incompletos" || cell.v === "No Verificada" || cell.v === "No Subida") {
                        cell.s = { fill: { fgColor: { rgb: "FFF8CBAD" } } }; // Red background
                    }
                }
            }
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const date = moment().format("YYYY-MMMM-DD---HH-mm-SS")
        // Convert the workbook to a binary file and trigger the download
        XLSX.writeFile(workbook, `usuarios_${date}.xlsx`);
    };

    const orderColumnsExcel = (usersToShow: ManageUser[]) => {
        return usersToShow.map((user) => {
            const {
                id,
                firstName,
                lastName, 
                mail,
                phoneNumber,
                jobs,
                Tax_Information, 
                nss_information,
                isProfilePicUploaded,
                isProfilePicVerified,
                isIdUploaded,
                isIdVerified,
                register_activity
            } = user
            return({
                id,
                Nombre: firstName, 
                Apellidos: lastName, 
                ultima_sesion: moment(register_activity).format("DD MMMM YYYY, HH:mm a"),
                Número_de_teléfono: phoneNumber,
                Email: mail,
                Número_de_habilidades: jobs.length,
                Nombres_de_habilidades: jobs.map((skill) => jobNames[skill]).join(","),
                Documentos_SAT: Tax_Information ? "Completos" : "Incompletos",
                CURP:                 nss_information?.curp ?? "",
                fecha_de_nacimiento:  nss_information?.fecha_de_nacimiento ?? "",
                lugar_de_nacimiento:  nss_information?.lugar_de_nacimiento ?? "",
                NSS:                  nss_information?.nss,
                Nombre_Completo:               nss_information?.nombre ?? "",
                Foto_Subida: isProfilePicUploaded ? "Subida" : "No Subida",
                Foto_Verificada: isProfilePicVerified ? "Verificada" : "No Verificada",
                INE_Subida: isIdUploaded ? "Subida" : "No Subida",
                INE_Verificada: isIdVerified ? "Verificada" : "No Verificada"
            })
        })
    }

    const searchSubmit = useCallback(
        (searchNameStr: string) => {
            if(!searchNameStr)
                return
            dispatch( GetUsersThunk({ searchNameStr, page: 1 }) )
    },[],)

    const resetSearchBar = useCallback(
      () => {
        dispatch(GetUsersThunk({ page: 1, limit: (limit > 0) ? limit : 25, searchNameStr: undefined }))
    },[limit],)

    const handleSendInformation = useCallback(
        () => {
            dispatch( setSendNotificationModalStateReducer() )
        },
        [],
    )
    
    const inputChangeToEmpty = useCallback(
        () => {
            resetSearchBar()
        },
        [],
    )
    

    return (
      <div className="flex flex-ai-center con-header-offers width-100">
            <p className="title-screen">{t("General:label_132")}</p>
            <SearcherBar style={{ width: "28rem" }} 
                ref={resetSearch} 
                searchSubmit={searchSubmit} 
                placeholder={t("General:label_133")} 
                addReset={true}
                resetSearchBar={resetSearchBar}
                inputChangeToEmpty={inputChangeToEmpty}
            />
            {
                accessEdit &&
                <button 
                    className="btn-request-product border-color-text border-radius-6 flex flex-ai-center ml-20 pl-12 pr-12 pointer"
                    onClick={handleSendInformation}
                >
                    <p className="fs-16-vh color-text">{t("General:label_275")}</p>
                </button> 
            }
            <div className="flex flex-jc-end mr-14 flex-1">
                <button
                    onClick={handleExport2}
                    className="c-white fs-12 picton-blue-bg export-form-btn"
                >
                    Export
                </button>
            </div>

      </div>
    )
}

export default React.memo( HeaderManageUsers )